/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GeneratedUserDto } from '../models/generated-user-dto';
import { getGeneratedUsers } from '../fn/session/get-generated-users';
import { GetGeneratedUsers$Params } from '../fn/session/get-generated-users';
import { getSessionInfo } from '../fn/session/get-session-info';
import { GetSessionInfo$Params } from '../fn/session/get-session-info';
import { issueTickerAuthToken } from '../fn/session/issue-ticker-auth-token';
import { IssueTickerAuthToken$Params } from '../fn/session/issue-ticker-auth-token';
import { requestTwoFactorCode } from '../fn/session/request-two-factor-code';
import { RequestTwoFactorCode$Params } from '../fn/session/request-two-factor-code';
import { SessionInfoDto } from '../models/session-info-dto';
import { signIn } from '../fn/session/sign-in';
import { SignIn$Params } from '../fn/session/sign-in';
import { signInExternal } from '../fn/session/sign-in-external';
import { SignInExternal$Params } from '../fn/session/sign-in-external';
import { SignInResponseDto } from '../models/sign-in-response-dto';
import { signInSixbid } from '../fn/session/sign-in-sixbid';
import { SignInSixbid$Params } from '../fn/session/sign-in-sixbid';
import { signOut } from '../fn/session/sign-out';
import { SignOut$Params } from '../fn/session/sign-out';
import { twoFactorRecoveryCodeSignIn } from '../fn/session/two-factor-recovery-code-sign-in';
import { TwoFactorRecoveryCodeSignIn$Params } from '../fn/session/two-factor-recovery-code-sign-in';
import { twoFactorSignIn } from '../fn/session/two-factor-sign-in';
import { TwoFactorSignIn$Params } from '../fn/session/two-factor-sign-in';

@Injectable({ providedIn: 'root' })
export class GeneratedSessionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSessionInfo()` */
  static readonly GetSessionInfoPath = '/api/session';

  /**
   * Gets information about the current session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSessionInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSessionInfo$Response(params?: GetSessionInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionInfoDto>> {
    return getSessionInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets information about the current session.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSessionInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSessionInfo(params?: GetSessionInfo$Params, context?: HttpContext): Observable<SessionInfoDto> {
    return this.getSessionInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionInfoDto>): SessionInfoDto => r.body)
    );
  }

  /** Path part for operation `signIn()` */
  static readonly SignInPath = '/api/session';

  /**
   * Sign in via username and password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signIn()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  signIn$Response(params: SignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
    return signIn(this.http, this.rootUrl, params, context);
  }

  /**
   * Sign in via username and password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `signIn$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  signIn(params: SignIn$Params, context?: HttpContext): Observable<SignInResponseDto> {
    return this.signIn$Response(params, context).pipe(
      map((r: StrictHttpResponse<SignInResponseDto>): SignInResponseDto => r.body)
    );
  }

  /** Path part for operation `signOut()` */
  static readonly SignOutPath = '/api/session';

  /**
   * Sign out.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signOut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  signOut$Response(params?: SignOut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return signOut(this.http, this.rootUrl, params, context);
  }

  /**
   * Sign out.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `signOut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  signOut(params?: SignOut$Params, context?: HttpContext): Observable<void> {
    return this.signOut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `twoFactorSignIn()` */
  static readonly TwoFactorSignInPath = '/api/session/mfa-token';

  /**
   * Complete the previous sign-in via MFA token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `twoFactorSignIn()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  twoFactorSignIn$Response(params: TwoFactorSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
    return twoFactorSignIn(this.http, this.rootUrl, params, context);
  }

  /**
   * Complete the previous sign-in via MFA token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `twoFactorSignIn$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  twoFactorSignIn(params: TwoFactorSignIn$Params, context?: HttpContext): Observable<SignInResponseDto> {
    return this.twoFactorSignIn$Response(params, context).pipe(
      map((r: StrictHttpResponse<SignInResponseDto>): SignInResponseDto => r.body)
    );
  }

  /** Path part for operation `requestTwoFactorCode()` */
  static readonly RequestTwoFactorCodePath = '/api/session/mfa-token';

  /**
   * Requests a new MFA token via mail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestTwoFactorCode()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  requestTwoFactorCode$Response(params: RequestTwoFactorCode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return requestTwoFactorCode(this.http, this.rootUrl, params, context);
  }

  /**
   * Requests a new MFA token via mail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestTwoFactorCode$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  requestTwoFactorCode(params: RequestTwoFactorCode$Params, context?: HttpContext): Observable<void> {
    return this.requestTwoFactorCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `twoFactorRecoveryCodeSignIn()` */
  static readonly TwoFactorRecoveryCodeSignInPath = '/api/session/mfa-recovery-code';

  /**
   * Sign in via a one-time password (recovery code).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `twoFactorRecoveryCodeSignIn()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  twoFactorRecoveryCodeSignIn$Response(params: TwoFactorRecoveryCodeSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
    return twoFactorRecoveryCodeSignIn(this.http, this.rootUrl, params, context);
  }

  /**
   * Sign in via a one-time password (recovery code).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `twoFactorRecoveryCodeSignIn$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  twoFactorRecoveryCodeSignIn(params: TwoFactorRecoveryCodeSignIn$Params, context?: HttpContext): Observable<SignInResponseDto> {
    return this.twoFactorRecoveryCodeSignIn$Response(params, context).pipe(
      map((r: StrictHttpResponse<SignInResponseDto>): SignInResponseDto => r.body)
    );
  }

  /** Path part for operation `signInExternal()` */
  static readonly SignInExternalPath = '/api/session/external';

  /**
   * Sign in via an external authentication provider.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signInExternal()` instead.
   *
   * This method doesn't expect any request body.
   */
  signInExternal$Response(params: SignInExternal$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
    return signInExternal(this.http, this.rootUrl, params, context);
  }

  /**
   * Sign in via an external authentication provider.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `signInExternal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  signInExternal(params: SignInExternal$Params, context?: HttpContext): Observable<SignInResponseDto> {
    return this.signInExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<SignInResponseDto>): SignInResponseDto => r.body)
    );
  }

  /** Path part for operation `signInSixbid()` */
  static readonly SignInSixbidPath = '/api/session/sixbid';

  /**
   * Sign in via a sixbid token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signInSixbid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  signInSixbid$Response(params: SignInSixbid$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
    return signInSixbid(this.http, this.rootUrl, params, context);
  }

  /**
   * Sign in via a sixbid token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `signInSixbid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  signInSixbid(params: SignInSixbid$Params, context?: HttpContext): Observable<SignInResponseDto> {
    return this.signInSixbid$Response(params, context).pipe(
      map((r: StrictHttpResponse<SignInResponseDto>): SignInResponseDto => r.body)
    );
  }

  /** Path part for operation `issueTickerAuthToken()` */
  static readonly IssueTickerAuthTokenPath = '/api/session/ticker_auth_token';

  /**
   * Issues a new authentication token for the ticker hub. Previous tokens will be revoked.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `issueTickerAuthToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  issueTickerAuthToken$Response(params?: IssueTickerAuthToken$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return issueTickerAuthToken(this.http, this.rootUrl, params, context);
  }

  /**
   * Issues a new authentication token for the ticker hub. Previous tokens will be revoked.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `issueTickerAuthToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  issueTickerAuthToken(params?: IssueTickerAuthToken$Params, context?: HttpContext): Observable<string> {
    return this.issueTickerAuthToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getGeneratedUsers()` */
  static readonly GetGeneratedUsersPath = '/api/session/generated-users';

  /**
   * Lists the users of a generated test system and their roles. Debug builds of a generated system only.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGeneratedUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneratedUsers$Response(params?: GetGeneratedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneratedUserDto>>> {
    return getGeneratedUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Lists the users of a generated test system and their roles. Debug builds of a generated system only.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGeneratedUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneratedUsers(params?: GetGeneratedUsers$Params, context?: HttpContext): Observable<Array<GeneratedUserDto>> {
    return this.getGeneratedUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GeneratedUserDto>>): Array<GeneratedUserDto> => r.body)
    );
  }

}
